import { render } from "./ai-form-radio-box.vue?vue&type=template&id=116792b6"
import script from "./ai-form-radio-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-radio-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/ai-form-radio-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "116792b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('116792b6', __exports__)) {
    api.reload('116792b6', __exports__)
  }
  
  module.hot.accept("./ai-form-radio-box.vue?vue&type=template&id=116792b6", () => {
    api.rerender('116792b6', render)
  })

}


export default __exports__